import { Tween } from "@westpierstudio/luma/createjs";
import { View } from "@westpierstudio/luma/mvc";
import { GameServices } from "game/GameServices";
import { CoreSymbolID } from "servertypes/SharedTypes";
import { MultiplierPanelsLayout } from "./multiplierpanels/MultiplierPanelsModel";
import { Spine } from "pixi-spine";
import { Signal } from "type-signals";

export class CollectionSymbol extends View {
    private readonly collectedSymbolIDS: CoreSymbolID[] = [`M1`, `M2`, `M3`, `F4`, `F5`, `F6`];
    private symbols: Map<CoreSymbolID, Spine>;

    public signals = {
        move: new Signal()
    };

    constructor(services: GameServices) {
        super(services);

        const {factory, resources} = this.services;
        const spec = resources.getSpec(`symbol-spines`);

        this.symbols = new Map();

        let spine;
        for (const id of this.collectedSymbolIDS) {

            spine = factory.createSpine(spec[id], this);
            spine.visible = false;

            this.symbols.set(id, spine);
        }
    }

    //To be called the frame before collection to prevent spine pop
    configureForCollection(symbol: CoreSymbolID, startPosition: {x: number, y: number}, initialScale: number,
        wheelPrize: boolean): void {

        const spine = this.symbols.get(symbol) as Spine;

        if (wheelPrize) {
            spine.state.setAnimation(0, `win-panel`, false);
        } else {
            spine.state.setAnimation(0, `multiplier-panel`, false);
        }

        spine.x = startPosition.x;
        spine.y = startPosition.y;
        spine.scale.x = initialScale;
        spine.scale.y = initialScale;
    }

    collect(symbol: CoreSymbolID, panelIndex: number, multiplierPanelsLayout: MultiplierPanelsLayout): void {

        const spine = this.symbols.get(symbol) as Spine;
        spine.visible = true;

        const collectTime = this.services.resources.getSetting(`multiplierPanel`).collectSymbolTime;
        const {globalSymbolPositions, symbolScale} = multiplierPanelsLayout;

        Tween.get(spine.position)
        .to(globalSymbolPositions[panelIndex], collectTime);

        Tween.get(spine.scale)
        .to({x: symbolScale, y: symbolScale}, collectTime)
        .call(() => {
            spine.visible = false;
        });

        Tween.get({})
            .wait(collectTime / 4)
            .call(() => this.signals.move.dispatch());
    }

    override reset(): void {
        for (const spine of this.symbols.values()) {

            Tween.removeTweens(spine.position);
            Tween.removeTweens(spine.scale);
            spine.visible = false;
        }
    }
}